module.exports = __webpack_public_path__ + "static/media/ircad-vert.0a154dec.svg";